export const JigsawMethod = {
  title: 'The Jigsaw Method',
  icon: '/static/templates_icons/JigsawMethod.svg',
  prompt: `
    <p class="pink-selectable">
      [Learn more about how to implement this activity in your classroom at
      <a target="_blank" href="https://parlayideas.com/templates/#jigsaw-method">https://parlayideas.com/templates/#jigsaw-method</a>]
    </p>
    <p class="pink-selectable">
      [Teacher to divide the class into 5 or 6 person groups, and have students sit together with their
      group. Try and randomize the groups as much as possible, so students can learn to work with
      new classmates. Each group will get a number.]
    </p>
    <h3>STEP 1 - Setting Up Groups</h3>
    <p>
      We’re going to divide the class into 5 or 6 person groups and sit with our group. Each group will
      get a number. Each group will choose one student to be the leader. The leader is responsible for
      submitting the Parlay Online RoundTable response on behalf of the group.
    </p>
    <h3>STEP 2 - Reviewing Materials</h3>
    <p>
      Review the following materials as a group. Only review the materials that relate to your group.
    </p>
    <p>
      <strong>Group 1 - <span class="pink-selectable">Topic Name</span></strong> <br>
      <span class="pink-selectable">[reference or link to materials here]</span>
    </p>
    <p>
      <strong>Group 2 - <span class="pink-selectable">Topic Name</span></strong> <br>
      <span class="pink-selectable">[reference or link to materials here]</span>
    </p>
    <p>
      <strong>Group 3 - <span class="pink-selectable">Topic Name</span></strong> <br>
      <span class="pink-selectable">[reference or link to materials here]</span>
    </p>
    <p>
      <strong>Group 4 - <span class="pink-selectable">Topic Name</span></strong> <br>
      <span class="pink-selectable">[reference or link to materials here]</span>
    </p>
    <p>
      <strong>Group 5 - <span class="pink-selectable">Topic Name</span></strong> <br>
      <span class="pink-selectable">[reference or link to materials here]</span>
    </p>
    <h3>STEP 3 - Group Submission</h3>
    <p>
      Work together to answer these questions as a group. The leader will be responsible for
      submitting the final response for the group.
    </p>
    <p>
      <strong>Group 1 - <span class="pink-selectable">Topic Name</span></strong> <br>
      <span class="pink-selectable">&nbsp;&nbsp; 	1. [insert Question 1 here] <br>
  	  &nbsp;&nbsp; 	2. [insert Question 2 here]</span>
    </p>
    <p>
      <strong>Group 2 - <span class="pink-selectable">Topic Name</span></strong> <br>
      <span class="pink-selectable">&nbsp;&nbsp; 	1. [insert Question 1 here] <br>
      &nbsp;&nbsp; 	2. [insert Question 2 here]</span>
    </p>
    <p>
      <strong>Group 3 - <span class="pink-selectable">Topic Name</span></strong> <br>
      <span class="pink-selectable">&nbsp;&nbsp; 	1. [insert Question 1 here] <br>
      &nbsp;&nbsp; 	2. [insert Question 2 here]</span>
    </p>
    <p>
      <strong>Group 4 - <span class="pink-selectable">Topic Name</span></strong> <br>
      <span class="pink-selectable">&nbsp;&nbsp; 	1. [insert Question 1 here] <br>
      &nbsp;&nbsp; 	2. [insert Question 2 here]</span>
    </p>
    <p>
      <strong>Group 5 - <span class="pink-selectable">Topic Name</span></strong> <br>
      <span class="pink-selectable">&nbsp;&nbsp; 	1. [insert Question 1 here] <br>
      &nbsp;&nbsp; 	2. [insert Question 2 here]</span>
    </p>
    <h3>STEP 4 - Exploration and Feedback:</h3>
    <p>
      All students in the group who were not the leader can join the RoundTable and press the “Skip
      Submission” button. This will allow to join the conversation without having to submit a response.
    </p>
    <p>
      Your next task is to provide comments and feedback. Pick one of the other groups’ submissions
      and answer the guided feedback questions provided.
    </p>
    <p>
      <strong>Important:</strong> everyone in your group should pick a different submission to read and respond to.
    </p>
    <h3>STEP 5 - Peer Teaching:</h3>
    <p>
      After everyone in the group has read and commented on at least one other group’s submission,
      go around the table in a circle with each group member responsible for:
    </p>
    <p>
      &nbsp;&nbsp;&nbsp;&nbsp; a) telling your group what you learned from reading that submission, <br>
      &nbsp;&nbsp;&nbsp;&nbsp; b) sharing the comments you made, and <br>
      &nbsp;&nbsp;&nbsp;&nbsp; c) explaining why you chose to make that comment.
    </p>
    <p>
      Encourage your group members to ask clarifying questions as you present your findings.
    </p>
    <h3>Step 6 - Feedback Review:</h3>
    <p>
      As a group, read through the comments that were made on your own groups’ submission and
      everyone pick one comment to reply to.
    </p>
  `,
};



// WEBPACK FOOTER //
// ./src/app/components/modals/New_RoundTable/EditorMCE/Templates/Defaults/TheJigsawMethod.js